<template>

  <ul
    class="list-group"
    v-if="questionnaireInvites.length"
    :class="{'box-loading': loading}">
    <li 
      class="list-group-item" 
      v-for="(questionnaireInvite, index) in questionnaireInvites"
      :key="index">
        <a
          v-if="permissions.includes('manage_candidates')"
          style="float: right;"
          href="javascript:void(0)"
          @click="removeQuestionnaireInvite(questionnaireInvite._id)">
          <i class="fas fa-times" />
        </a>
        <Bullet
          :title="{ pending: 'Pendente', complete: 'Finalizado' }[questionnaireInvite.status]"
          :status="{ pending: 'warning', complete: 'success' }[questionnaireInvite.status]" />
        Questionário
        <strong>{{ questionnaireInvite.questionform_id.name }}</strong>
        solicitado em {{ $d(new Date(questionnaireInvite.created_at), 'short') }}
    </li>
  </ul>

</template>

<script>
import Bullet from '@/components/Parts/Bullet'

export default {
  name: 'CandidateQuestionnaireInviteList',
  components: {
    Bullet
  },
  props: [
  ],
  data () {
    return {
      creating: false,
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    onlyThisJob () {
      return this.$store.getters.getCandidateOnlyThisJob
    },
    questionnaireInvites () {
      return this.$store.getters.getQuestionnaireInvites
    }
  },
  watch: {
    'selectedJob._id': function (val) {
      this.loadData(1)
    },
    onlyThisJob: function (val) {
      this.loadData(1)
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
  },
  methods: {
    loadData () {
      this.loading = true

      let params = {
        candidate_id: this.candidate._id,
        sort: '-created_at'
      }

      if (this.selectedJob && this.onlyThisJob) {
        params.job_id = this.selectedJob.job_id
      }

      this.$store
      .dispatch('selectQuestionnaireInvites', params)
      .then((response) => {
        this.loading = false
      })
    },
    removeQuestionnaireInvite (id) {
      const deleteAction = () => {
        this.loading = true

        return this.$store
        .dispatch('deleteQuestionnaireInvite', id)
        .then((response) => {
          this.loading = false
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Questionnaire/CandidateQuestionnaireInviteList.vue